import { useNotify, useRedirect, SaveButton } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { ActionTitles } from '../Constants';
import { baseButtonStyle, padding0, padding2 } from '../Styles';
import { Button, Grid } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import { getCreationMessage } from '../../utils/util';

export const Toolbar = (props) => {
  const { disabled } = props;
  const notify = useNotify();
  const redirect = useRedirect();
  const customisation = useWatch({ name: 'customisation' });
  const reportThemeTemplateId = useWatch({ name: 'reportThemeTemplateId' });  

  const buttonTitle = customisation === false && reportThemeTemplateId
    ? ActionTitles.ASSIGN
    : (props.buttonTitle ?? ActionTitles.CREATE);

  const onSuccess = (data) => {
    const message = getCreationMessage(props.resource, props.isEdit, data);
    notify(message, { type: 'info', autoHideDuration: 1000 });
    if(props.isEdit){
      redirect(props.basePath + '/' + data.clientReportThemeId + '/show');
    }else{
      const id = customisation === false && reportThemeTemplateId
        ? `client/${data.clientId}/template/${reportThemeTemplateId}`
        : data.id;
      redirect(props.basePath + '/' + encodeURIComponent(id) + '/show');
    }
  };

  const onFailure = (error) => {
    notify(error.message, { type: 'warning', autoHideDuration: 1000 });
  };

  return (
    <ListItem sx={{ ...padding0.top, ...padding2.bottom }}>
      <Grid container justifyContent="flex-end">
        <Grid container item xs={12} lg={10} justifyContent="flex-end">          
          <Grid container item xs={12} md={3}>
            <Button
              id="report-theme-toolbar-cancel-button"
              variant="outlined"
              size="medium"
              sx={{ ...baseButtonStyle("grey", "white", "#eaeaea", "#b2afaf", "#9B9999") }}
              onClick={() => redirect(props.basePath)}
            >
              {ActionTitles.CANCEL}
            </Button>
          </Grid>          
          <Grid container item xs={12} md={3}>
            <SaveButton
              id="report-theme-toolbar-save-button"
              type="button"
              icon={<div />}
              size="medium"
              mutationOptions={{ onSuccess: onSuccess, onError: onFailure }}
              label={buttonTitle}
              sx={{ ...baseButtonStyle() }}
              data-testid="submit-report-theme"
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default Toolbar;